function isEmail(text: string) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(text)
}

function isCompleteUrl(text: string) {
  try {
    new URL(text)
    return true
  } catch (_) {
    return false
  }
}

/**
 * url sanitization for markdown links, if the url is an email it will be
 * added the `mailto:` to enable on click to send an email to that url,
 * if it is a complete url it will be returned as is, otherwise it will
 * be treatea as a relative path of the shell url.
 */
export function sanitizeuUrl(url: string) {
  const email = isEmail(url)
  const isUrl = isCompleteUrl(url)
  if (email) {
    return `mailto:${url}`
  } else if (isUrl) {
    return url
  } else {
    const trimmedUrl = url.startsWith('/') ? url.slice(1) : url
    return `/${trimmedUrl}`
  }
}
